module.exports = __webpack_public_path__ + "images/d978b01b5598fe0566c25289337c61e42aa2e5dc7540d1ce22b06897c35379c9.svg";